import Vue from 'vue'
import InputProject from '../../views/Project_v2/Project_components/InputProject.vue'
import Input from '../../views/Project_v2/Project_components/BaseInput.vue'
import BaseButton from '../BaseButton/BaseButton.vue'
export default Vue.extend({
    name: 'WithdrawalModal',
    components: {
        InputProject,
        BaseButton,
        Input
    },
    props: {
        clicked: Boolean
    },
    data() {
        return {
            text: '',
            submit: false,
            modal: true
        }
    },
    methods: {
        changeVision() {
            this.$store.dispatch('changeVisionConfirm')
        },
        change_modal() {
            this.$emit('changemodal', false)
        }
    }
})